export const allRestaurants = [
  {
    data: {
      id: "255655",
      name: "Cake & Cream",
      cloudinaryImageId: "ac57cc371e73f96f812613f58457aca3",
      locality: "Jairaj Nagar",
      areaName: "Jairaj Nagar",
      costForTwo: "₹200 for two",
      cuisines: ["Bakery", "Hot Dog", "Pastry", "Cake", "Thick Shake"],
      avgRating: 4.3,
      veg: true,
      parentId: "54670",
      offer: "30",
      timeToDeliver: 2100,
      avgRatingString: "4.3",
      totalRatingsString: "20+",
    },
  },
  {
    data: {
      id: "350363",
      name: "Haldiram's Sweets and Namkeen",
      cloudinaryImageId: "25c3a7d394d6c5556b134385f7d665b0",
      locality: "Civil Line",
      cuisines: [
        "North Indian",
        "South Indian",
        "Chinese",
        "Pizzas",
        "Fast Food",
      ],
      avgRating: 4.6,
      veg: true,
      parentId: "391465",
      offer: "50",
      timeToDeliver: 3500,
      avgRatingString: "4.6",
      totalRatingsString: "100+",
    },
  },
  {
    data: {
      id: "154891",
      name: "Rasraj Restaurant",
      cloudinaryImageId: "egbr63ulc8h1zgliivd8",
      locality: "Civil Line",
      areaName: "Civil Lines",
      costForTwo: "₹250 for two",
      cuisines: [
        "North Indian",
        "South Indian",
        "Street Food",
        "Chinese",
        "Pizzas",
        "Fast Food",
      ],
      avgRating: 4.2,
      offer: "40",
      timeToDeliver: 1000,
      avgRatingString: "4.2",
    },
  },
  {
    data: {
      id: "745961",
      name: "Balaji Restaurant",
      cloudinaryImageId: "b8672fe52944c3599ea324d99d608300",
      locality: "Sai Rubber Stamp",
      areaName: "Jairaj Nagar",
      costForTwo: "₹149 for two",
      cuisines: ["South Indian", "North Indian"],
      avgRating: 4.8,
      veg: true,
      offer: "30",
      timeToDeliver: 5100,
      avgRatingString: "4.8",
    },
  },
  {
    data: {
      id: "798745",
      name: "Friends Restaurant",
      cloudinaryImageId: "b14cd9fc40129fcfb97aa7e621719d07",
      locality: "Gayatri Nagar",
      areaName: "Jairaj Nagar",
      costForTwo: "₹150 for two",
      cuisines: ["North Indian", "Chinese", "Biryani", "Tandoor", "Kebabs"],
      avgRating: 4.2,
      parentId: "84308",
      offer: "45",
      timeToDeliver: 3200,
      avgRatingString: "4.2",
    },
  },
  {
    data: {
      id: "314737",
      name: "RASOI the KITCHEN",
      cloudinaryImageId: "yjymo9nhyn7rhvafsrd3",
      locality: "Sriram Chowk",
      areaName: "Bazar Ward",
      costForTwo: "₹200 for two",
      cuisines: ["North Indian", "Maharashtrian", "Chinese", "Thalis"],
      avgRating: 3.9,
      parentId: "167341",
      offer: "30",
      timeToDeliver: 2100,
      avgRatingString: "3.9",
    },
  },
  {
    data: {
      id: "201454",
      name: "Morsels Restaurants",
      cloudinaryImageId: "aafe71251ef5328784652dc838cd91f3",
      locality: "Bazar Ward",
      areaName: "Chandrapur Locality",
      costForTwo: "₹300 for two",
      cuisines: ["North Indian", "South Indian"],
      avgRating: 3.2,
      veg: true,
      parentId: "139266",
      offer: "50",
      timeToDeliver: 2200,
      avgRatingString: "3.2",
    },
  },
  {
    data: {
      id: "266124",
      name: "Trimurti Restaurant",
      cloudinaryImageId: "8135c0066b06e2925c66930be4e9ffb5",
      locality: "Bazar Ward",
      areaName: "Chandrapur Locality",
      costForTwo: "₹150 for two",
      cuisines: ["Desserts"],
      avgRating: 3.9,
      veg: true,
      parentId: "217751",
      offer: "30",
      timeToDeliver: 2500,
      avgRatingString: "3.9",
    },
  },
  {
    data: {
      id: "509254",
      name: "Saha Restaurant",
      cloudinaryImageId: "z1ez4uc9idul2uj2v87g",
      locality: "Jairaj Nagar",
      areaName: "Jairaj Nagar",
      costForTwo: "₹300 for two",
      cuisines: ["North Indian", "Biryani", "Thalis", "Beverages"],
      avgRating: 3.7,
      parentId: "174585",
      offer: "10",
      timeToDeliver: 2800,
      avgRatingString: "3.7",
    },
  },
];

export const foodTypes = [
  {
    id: 1,
    name: "pothichoru",
    urlCode: "Pottichur.png",
  },
  {
    id: 2,
    name: "South Indian",
    urlCode: "South%20Indian.png",
  },
  {
    id: 3,
    name: "North Indian",
    urlCode: "North%20Indian.png",
  },
  {
    id: 4,
    name: "Biryani",
    urlCode: "Biryani.png",
  },
  {
    id: 5,
    name: "Chinese",
    urlCode: "Chinese.png",
  },
  {
    id: 6,
    name: "Shawarma",
    urlCode: "Shawarma.png",
  },
  {
    id: 7,
    name: "Burger",
    urlCode: "Burger.png",
  },
  {
    id: 8,
    name: "Desserts",
    urlCode: "Desserts.png",
  },
  {
    id: 9,
    name: "Ice Cream",
    urlCode: "Ice%20Cream.png",
  },
  {
    id: 10,
    name: "Salad",
    urlCode: "Salad.png",
  },
  {
    id: 11,
    name: "Dosa",
    urlCode: "Dosa.png",
  },
  {
    id: 12,
    name: "Noodles",
    urlCode: "Noodles.png",
  },
];
